import React, { useState } from 'react';

import { ICartV2 } from 'src/explore/types/shoppe';

import styles from './index.module.sass';
import StripePaymentButton from './compositions/StripePaymentButton';

interface ExpressCheckoutProps {
  cart: ICartV2;
}

const ExpressCheckout: React.FC<ExpressCheckoutProps> = ({ cart }) => {
  const [ showStripeButton, setShowStripeButton ] = useState( true );

  if ( !showStripeButton ) return null;

  return (
    <div className={styles.container}>
      <div className={styles.title}>Express Checkout</div>
      <div className={styles.buttonsContainer}>
        {showStripeButton && (
          <div className={styles.buttonContainer}>
            <StripePaymentButton cart={cart} setVisible={setShowStripeButton} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ExpressCheckout;
